  // size chart
(function () {
  function activate(modal, idx) {
    const tabs = modal.querySelectorAll('[data-sc-tab]');
    const panels = modal.querySelectorAll('[data-sc-panel]');

    tabs.forEach((t, i) => {
      const active = i === idx;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach((p, i) => {
      if (i === idx) {
        p.classList.add('is-active');
        p.removeAttribute('hidden');
      } else {
        p.classList.remove('is-active');
        p.setAttribute('hidden', '');
      }
    });
  }

  function openModal(modal, trigger) {
    if (!modal) return;
    modal.__lastFocus = document.activeElement;

    modal.hidden = false;
    requestAnimationFrame(() => modal.classList.add('is-open'));
    document.documentElement.style.overflow = 'hidden';

    // Keep first tab open
    activate(modal, 0);

    const firstTab = modal.querySelector('[data-sc-tab]');
    if (firstTab) firstTab.focus();

    // store trigger for restore focus
    modal.__trigger = trigger;
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';

    setTimeout(() => {
      modal.hidden = true;
      const lf = modal.__lastFocus || modal.__trigger;
      if (lf && lf.focus) lf.focus();
    }, 220);
  }

  function initModal(modal) {
    if (modal.__scInit) return;
    modal.__scInit = true;

    // Close handlers
    modal.querySelectorAll('[data-sc-close]').forEach((el) => {
      el.addEventListener('click', () => closeModal(modal));
    });

    // Tabs
    modal.querySelectorAll('[data-sc-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        activate(modal, Number(tab.dataset.scTab));
      });
    });
  }

  function initTriggers() {
    const triggers = document.querySelectorAll('[data-sc-open]');
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const id = trigger.getAttribute('data-sc-open');
        const modal = document.getElementById(id);
        if (!modal) return;

        initModal(modal);
        openModal(modal, trigger);
      });
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-sc-modal]').forEach((modal) => {
      if (!modal.hidden) closeModal(modal);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTriggers);
  } else {
    initTriggers();
  }
})();